import React from 'react'
import Table from 'shared/components/Table'
import ActionButton from './ActionButton'
import { Label } from 'semantic-ui-react'
import styled from 'styled-components'

const GroupTable = ({
  dataSource,
  handleEditAction,
  paginationCurrent,
  paginationPageSize,
  handlePageChange,
  total,
  allowAdminOrAbove,
  handleDelete,
}) => {
  const columns = [
    {
      title: 'Group',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: 120,
      render(_, data) {
        return (
          <div className="flex items-center">
            <div className="truncate">{data.name}</div>
          </div>
        )
      },
      sorter(dataA, dataB) {
        const labelA = dataA.name
        const labelB = dataB.name
        return (labelA || '').localeCompare(labelB)
      },
      sortDirections: ['ascend', 'descend'],
      defaultSortOrder: 'ascend',
    },
    {
      title: 'Source',
      dataIndex: 'source',
      key: 'source',
      width: 80,
      render(_, data) {
        return (
          <div className="flex items-center">
            <Label basic>{data.is_predefined ? 'Default' : 'Custom'}</Label>
          </div>
        )
      },
      sorter(dataA, dataB) {
        return dataA.is_predefined - dataB.is_predefined
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: '',
      key: 'action',
      align: 'right',
      width: 30,
      render(_, data) {
        if (!data.is_predefined) {
          return (
            allowAdminOrAbove && (
              <ActionButton
                data={data}
                status={null}
                showEdit={true}
                showDelete={true}
                handleDelete={handleDelete}
                tabName="topicGroup"
                handleEditAction={handleEditAction}
                handleToggleActive={() => {}}
              />
            )
          )
        }
      },
    },
  ]

  return (
    <div>
      <AntdGroupTable
        variant="indexPage"
        clickable={false}
        dataSource={dataSource}
        className="topic-group-table"
        columns={columns}
        pagination={
          total > 50
            ? {
                current: paginationCurrent,
                pageSize: paginationPageSize,
                total: total,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '500'],
                onChange: (page, pageSize) => handlePageChange(page, pageSize, 'topicGroup'),
                onShowSizeChange: (current, size) => handlePageChange(current, size, 'topicGroup'),
              }
            : false
        }
      />
    </div>
  )
}

export default GroupTable

const AntdGroupTable = styled(Table)`
  &.topic-group-table .ant-table {
    position: relative;
    z-index: 1;
  }

  &.topic-group-table .ant-table-pagination.ant-pagination {
    display: block;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/GroupTable.js